'use strict'
var aiModule = angular.module('aiModule',[
	'ui.router',
	'servicesModule',
	'ngResource',
	"ngTable",
	'ngBootstrap',
	'thatisuday.dropzone',
	'ngSanitize'
	
]);
require('./all-configurations/js/directive/aiAllConfigurationsDirective.js')(aiModule);
require('./all-configurations/js/aiAllConfigurationsController.js')(aiModule);
require('./create-edit-configuration/js/directive/aiConfigurationDirective.js')(aiModule);
require('./create-edit-configuration/js/aiConfigurationController.js')(aiModule);


//////////////////
// WEBPACK FOOTER
// ./public/development/assets/ext-modules/aiModule/aiModule.js
// module id = 485
// module chunks = 0